<script setup>
import { ref, onBeforeMount } from 'vue'
import axios from '../plugins/axios'
import PacketRow from '../components/PacketRow.vue'

const packets = ref(null)
const customTemplates = ref(null)

async function getPackets() {
  const { data } = await axios.get(`/v2/packets`)
  //console.log('API Response:', data)
  packets.value = data.packets
  customTemplates.value = data.templates
  //console.log('Templates:', customTemplates.value)
  // Debug template access
//   if (data.packets && data.packets.length > 0) {
//     console.log('First packet satellite:', data.packets[0].satellite)
//     console.log('Template for first packet:', data.templates[data.packets[0].satellite])
//  }
}

onBeforeMount(getPackets)
</script>

<template>
  <div class="packets">
    <h1 class="subheading grey--text">Last packets</h1>
    <v-container>
      <v-layout row wrap v-if="packets">
        <v-flex xs12 sm12 pa-4>
          <div v-for="packet in packets" :key="packet.id">
            <PacketRow
              :packet="packet"
              :customTemplate="customTemplates[packet.satellite]"
            />
            <v-divider></v-divider>
          </div>
        </v-flex>
      </v-layout>
      <v-row v-else class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular indeterminate color="grey"></v-progress-circular>
      </v-row>
    </v-container>
  </div>
</template>

<style>
</style>